"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { SelectIcon as t, SelectRoot as n, SelectTrigger as r, SelectValue as i } from "../../atoms/Select/Select.mjs";
import { useId as a } from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { cva as c } from "class-variance-authority";
//#region src/components/molecules/MediaSelect/MediaSelect.tsx
var l = c("flex items-center border font-semibold text-base [&_[data-slot=select-value]_span]:font-semibold dark:bg-neutral-dark-100 dark:text-neutral-dark-1000 dark:border-transparent dark:hover:not-disabled:border-neutral-dark-600 dark:disabled:text-neutral-dark-600", {
	variants: { variant: {
		default: "h-14 min-w-32 w-fit rounded-full p-4 gap-4",
		"icon-only": "h-10 w-11 rounded-3xl px-2 py-4 gap-1"
	} },
	defaultVariants: { variant: "default" }
}), u = ({ className: c, children: u, variant: d = "default", icon: f, placeholder: p, selectTriggerProps: m, selectValueProps: h, ...g }) => {
	let _ = d === "icon-only", v = a();
	return /* @__PURE__ */ s(n, {
		...g,
		children: [/* @__PURE__ */ o(r, {
			"aria-labelledby": _ ? void 0 : v,
			"aria-label": _ ? p : void 0,
			iconPrefix: f ? /* @__PURE__ */ o("span", {
				className: "[&_path]:fill-white",
				children: f
			}) : void 0,
			iconSuffix: /* @__PURE__ */ o(t, { className: e(_ ? "size-2" : "size-4") }),
			className: e(l({ variant: d }), c),
			...m,
			children: !_ && /* @__PURE__ */ o(i, {
				id: v,
				placeholder: p,
				...h
			})
		}), u]
	});
};
//#endregion
export { u as MediaSelect };
